import i18n from '../../../i18n';

export default {
  responses: 'پاسخهای مرتبط',
  score: 'امتیاز:',
  answer: 'جواب',
  rowNumber: 'ردیف',
  addChoices: 'افزودن گزینه',
  updateDate: 'تاریخ بروزرسانی',
  answeredBy: 'ارسال کننده:',
  description: 'توضیحات: ',
  submitDate: 'تاریخ ارسال:',
  subQuestion: 'گام',
  withoutScore: 'بدون امتیاز',
  effectiveDate: 'بازه‌ی ارسال: ',
  responseTitle: 'عنوان:',
  noQuestionFind: 'سؤالی برای نمایش وجود ندارد',
  addQuestionTags: 'انتخاب برچسب',
  relatedResponses: 'پاسخ‌های مرتبط',
  filterWithChoices: 'فیلتر با گزینه‌ها',
  separatedBySendTime: 'به تفکیک ارسال',
  separatedByQuestion: 'به تفکیک سوال',
  filterWithQuestionsTags: 'فیلتر با برچسب‌های سؤال‌ها',
  loadingRelatedResponseList: 'در حال دریافت اطلاعات...',
  itemNotFound: 'موردی پیدا نشد',
  print: 'چاپ',
  printEachItemInAPage: 'چاپ هر آیتم در یک صفحه',
  splitPerDistrict: 'به تفکیک بخش',
  exelExport: 'خروجی اکسل',
  exelExportForAccredit: 'خروجی اکسل (مخصوص سنجه‌های اعتباربخشی)',
  entireHospital: 'کل بیمارستان',
  surveyName: 'پرسشنامه',
  questionName: 'سوال',
  subQuestionName: 'گام',
  distinctiveAnswers: 'بخش',
  relatedDate: 'بازه مرتبط',
  response: 'پاسخ',
  responseValue: 'مقدار پاسخ',
  tags: 'دسته بندی',
  senderName: 'ارسال کننده',
  standard: 'استاندارد',
  indicator: 'سنجه',
  part: 'گام',

  countOfGridParts(size: string) {
    return i18n.t('countOfGridParts', { ns: 'survey', size });
  },
};
